import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import type { GridColDef } from '@p81-common/ui';
import { Chips } from '@p81-common/ui';
import EdgeStatusBadge from '../parts/EdgeStatusBadge';

export const useTableSettings = () => {
  const { t } = useTranslation('edges');
  const tableConfig: GridColDef[] = [
    {
      isSortable: true,
      field: 'edge_id',
      title: t('EDGES_TABLE.EDGE_ID'),
      show: true,
      width: 136,
      fieldsToExport: [],
      renderCell: params => {
        const { row } = params;
        return (
          <NavLink
            to={`/cs/edges/${row.edge_id}?jarvisRegion=${row.data_residency}`}
          >
            {row.edge_id}
          </NavLink>
        );
      }
    },
    {
      isSortable: true,
      field: 'data_residency',
      title: t('EDGES_TABLE.DR'),
      show: true,
      width: 88,
      fieldsToExport: []
    },
    {
      isSortable: true,
      field: 'region_name',
      title: t('EDGES_TABLE.REGION_NAME'),
      show: true,
      width: 160,
      fieldsToExport: []
    },
    {
      isSortable: false,
      field: 'region_provider',
      title: t('EDGES_TABLE.REGION_PROVIDER'),
      show: true,
      width: 156,
      fieldsToExport: []
    },
    {
      isSortable: false,
      field: 'edge_version',
      title: t('EDGES_TABLE.EDGE_VERSION'),
      show: true,
      width: 120,
      fieldsToExport: []
    },
    {
      isSortable: true,
      field: 'network_count',
      title: t('EDGES_TABLE.NW_COUNT'),
      show: true,
      width: 160,
      fieldsToExport: []
    },
    {
      isSortable: false,
      field: 'edge_ip',
      title: t('EDGES_TABLE.EDGE_IP'),
      show: true,
      width: 144,
      fieldsToExport: []
    },
    {
      isSortable: true,
      field: 'status',
      title: t('EDGES_TABLE.EDGE_STATUS'),
      show: true,
      width: 112,
      fieldsToExport: [],
      renderCell: params => {
        const { row } = params;
        return <EdgeStatusBadge status={row.status} />;
      }
    },
    {
      isSortable: false,
      field: 'machine_type',
      title: t('EDGES_TABLE.TYPE'),
      show: true,
      width: 144,
      fieldsToExport: []
    },
    {
      isSortable: false,
      field: 'machine_size',
      title: t('EDGES_TABLE.SIZE'),
      show: true,
      width: 150,
      fieldsToExport: []
    }
  ];

  const networksTableConfig: GridColDef[] = [
    {
      isSortable: false,
      field: 'network_id',
      title: t('NETWORKS_TABLE.NETWORK_ID'),
      show: true,
      width: 150,
      fieldsToExport: [],
      renderCell: params => {
        const { row } = params;
        return (
          <NavLink
            to={`/customers/all-tenants/${row.customer_id}/platform/networks/${row.network_id}/network?jarvisRegion=${row.data_residency}`}
          >
            {row.network_id}
          </NavLink>
        );
      }
    },
    {
      isSortable: false,
      field: 'network_name',
      title: t('NETWORKS_TABLE.NETWORK_NAME'),
      show: true,
      width: 184,
      fieldsToExport: []
    },
    {
      isSortable: false,
      field: 'customer_id',
      title: t('NETWORKS_TABLE.CUSTOMER_ID'),
      show: true,
      width: 184,
      fieldsToExport: []
    },
    {
      isSortable: false,
      field: 'customer_name',
      title: t('NETWORKS_TABLE.COMPANY_NAME'),
      show: true,
      width: 184,
      fieldsToExport: []
    },
    {
      isSortable: false,
      field: 'role',
      title: t('NETWORKS_TABLE.PRIMARY_SECONDARY'),
      show: true,
      width: 184,
      fieldsToExport: [],
      renderCell: params => {
        const { row } = params;
        return (
          <Chips
            label={row.role}
            color={row.role === 'primary' ? 'primary' : 'default'}
            size="small"
          />
        );
      }
    },
    {
      isSortable: false,
      field: 'data_residency',
      title: t('NETWORKS_TABLE.DATA_RESIDENCY'),
      show: true,
      width: 184,
      fieldsToExport: []
    }
  ];

  return {
    tableConfig,
    networksTableConfig
  };
};
